export default "__VITE_ASSET__bb54e251__"